/* ============================================
   Splendido Wishlist toggle — global JS
   ============================================
   - Source of truth: localStorage['splendido_wishlist'] = JSON array of product handles
   - Wires every [data-wishlist-toggle] button on the page to add/remove its handle
   - Syncs visual state (.is-active + aria-pressed + aria-label) on load and on toggle
   - Updates every header counter [data-wishlist-counter]
   - Cross-tab sync via the storage event
   - Re-applies state on Shopify "shopify:section:load" (theme editor) and on Prestige
     custom product-card re-renders, using a MutationObserver fallback.
   ============================================ */
(function () {
  'use strict';

  var KEY = 'splendido_wishlist';
  var EVENT = 'splendido:wishlist:changed';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h.length > 0; }) : [];
    } catch (e) {
      return [];
    }
  }

  /* Ritorna true solo se il salvataggio è andato a buon fine. Serve a non accendere il cuore
     quando lo storage è bloccato (navigazione privata di vecchi browser, storage disabilitato,
     quota piena): meglio nessuna reazione che un cuore acceso che sparisce al refresh. */
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
      return true;
    } catch (e) {
      return false;
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function add(handle) {
    var list = read();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      return write(list);
    }
    return true;
  }

  function remove(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    return write(list);
  }

  /* Avvisa gli altri moduli (pagina Wunschliste, drawer, badge) che la lista è cambiata. */
  function notifyChange(handle, active) {
    try {
      window.dispatchEvent(new CustomEvent(EVENT, { detail: { handle: handle, active: active, list: read() } }));
    } catch (e) {}
  }

  /* Selettore per attributo a prova di caratteri speciali negli handle. */
  function escapeForSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return value.replace(/["\\]/g, '\\$&');
  }

  function applyVisualState(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var addLbl = btn.getAttribute('data-label-add') || 'Zur Wunschliste hinzufügen';
    var rmLbl  = btn.getAttribute('data-label-remove') || 'Von Wunschliste entfernen';
    btn.setAttribute('aria-label', active ? rmLbl : addLbl);
  }

  function syncAllButtons() {
    var list = read();
    var set = {};
    for (var i = 0; i < list.length; i++) set[list[i]] = true;
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var j = 0; j < btns.length; j++) {
      var h = btns[j].getAttribute('data-handle');
      if (!h) continue;
      applyVisualState(btns[j], !!set[h]);
    }
  }

  function updateCounters() {
    var n = read().length;
    var counters = document.querySelectorAll('[data-wishlist-counter]');
    for (var i = 0; i < counters.length; i++) {
      counters[i].textContent = String(n);
      counters[i].classList.toggle('is-visible', n > 0);
    }
  }

  function handleClick(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    // If the toggle was placed inside an <a>, prevent navigation.
    if (e.cancelable) e.preventDefault();
    /* NB (2026-08-03): capture + stopPropagation sono VOLUTI e vanno tenuti. Grazie al return qui
       sopra agiscono solo sui click che colpiscono il cuore, mai sul resto della pagina; servono
       perché il cuore è sovrapposto (z-index) al link della product-card e a eventuali handler del
       tema, che altrimenti aprirebbero la scheda prodotto mentre si aggiunge alla lista. */
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var active = !has(handle);
    var saved = active ? add(handle) : remove(handle);
    /* Storage non disponibile: non tocchiamo la grafica, così non mostriamo uno stato falso. */
    if (!saved) return;
    applyVisualState(btn, active);
    // Sync any other instances of the same handle on the page (e.g. featured + grid).
    var siblings = document.querySelectorAll('[data-wishlist-toggle][data-handle="' + escapeForSelector(handle) + '"]');
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] !== btn) applyVisualState(siblings[i], active);
    }
    updateCounters();
    notifyChange(handle, active);
  }

  function init() {
    syncAllButtons();
    updateCounters();
  }

  // Click delegation on document — survives any DOM swap.
  document.addEventListener('click', handleClick, true);

  /* Cross-tab sync.
     BUGFIX 2026-08-03: il filtro era `e.key === KEY`, ma la pagina Wunschliste (sections/wishlist.liquid,
     setList) notifica le sue rimozioni con un `new Event('storage')` SINTETICO, che non ha `key` →
     veniva scartato e il contatore nell'intestazione restava indietro finché non si ricaricava
     (riprodotto sul live: lista da 3 a 2, badge fermo su 3). Ora si accettano anche gli eventi
     sintetici, e si ignorano solo quelli di ALTRE chiavi. */
  window.addEventListener('storage', function (e) {
    if (e && e.key && e.key !== KEY) return;
    syncAllButtons();
    updateCounters();
  });

  /* Stessa scheda: qualsiasi modulo può segnalare una modifica con l'evento custom. */
  window.addEventListener(EVENT, function () { syncAllButtons(); updateCounters(); });

  // Theme editor: re-init when a section is reloaded.
  document.addEventListener('shopify:section:load', init);

  // Prestige replaces <product-card> nodes on variant changes / ajax loads;
  // re-sync when new toggles appear.
  if ('MutationObserver' in window) {
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        syncAllButtons();
      });
    });
    /* SPLENDIDO 2026-09-26 (audit COD-02): prima osservava TUTTO il documento, a ogni pagina. Ora solo i tre
       contenitori dove possono comparire cuori nuovi dopo il caricamento: la pagina (#main: griglie, "Mehr laden",
       filtri, Schnellansicht), i risultati della ricerca nell'intestazione e il cassetto del carrello (prodotti
       consigliati). Se nessuno dei tre esiste, si torna al comportamento di prima. */
    var cassetto = document.querySelector('.shopify-section--cart-drawer');
    var radici = [document.getElementById('main'), document.getElementById('header-predictive-search'), cassetto];
    var osservate = 0;
    for (var r = 0; r < radici.length; r++) {
      if (radici[r]) { mo.observe(radici[r], { childList: true, subtree: true }); osservate++; }
    }
    if (!osservate) mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
